import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LoginPage } from '@/pages/LoginPage';
import { AIPage } from '@/pages/AIPage';
import { KretskampenPage } from '@/pages/KretskampenPage';
import { MailAssistantPage } from '@/pages/MailAssistantPage';
import { InsightsPage } from '@/pages/InsightsPage';
import { KnowledgeBasePage } from '@/pages/KnowledgeBasePage';
import { GranskningPage } from '@/pages/GranskningPage';
import { StatusPage } from '@/pages/StatusPage';
import { NastaStegPage } from '@/pages/NastaStegPage';
import { MotenPage } from '@/pages/MotenPage';
import FeedbackPage from './pages/FeedbackPage';
import { Shell } from '@/components/layout/Shell';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';
import { ChatProvider } from '@/contexts/ChatContext';
import { useSalesPreview } from '@/hooks/useSalesPreview';

/**
 * Säljpresentationen är inte bara dold i menyn — den som gissar URL:en utan
 * att stå med i VITE_PRESENTATION_EMAILS skickas tillbaka till startsidan.
 */
function NastaStegRoute() {
  const { canSee, loading } = useSalesPreview();
  if (loading) return null;
  return canSee ? <NastaStegPage /> : <Navigate to="/" replace />;
}

/**
 * /insikter är ett gammalt namn på startsidan. Frågedelen följer med –
 * ledningsrapportens mejl länkar till /insikter?flik=ledningsrapport.
 */
function InsikterTillStart() {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: '/', search, hash }} replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <ChatProvider>
              <Shell />
            </ChatProvider>
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<InsightsPage />} />
        <Route path="/ai-analys" element={<AIPage />} />
        <Route path="/mail" element={<MailAssistantPage />} />
        <Route path="/moten" element={<MotenPage />} />
        <Route path="/moten/:id" element={<MotenPage />} />
        <Route path="/kretskampen" element={<KretskampenPage />} />
        <Route path="/kunskapsbas" element={<KnowledgeBasePage />} />
        <Route path="/granskning" element={<GranskningPage />} />
        <Route path="/status" element={<StatusPage />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/nasta-steg" element={<NastaStegRoute />} />
        <Route path="/insikter" element={<InsikterTillStart />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
